import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React = require('react');
import { LoginUrlsWrapper } from '~src/authentication/components/loginSpace/LoginUrls';
import { SignInLogo } from '~src/authentication/components/loginSpace/SignInLogo';
import { Messages } from '~src/codegen/Localize';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';

import { PasswordResetForm } from './PasswordResetForm';

export function PasswordResetPage() {
    const [showPasswordResetForm , setShowPasswordResetForm ] = React.useState(true);

    if (!ServerSettingsUnauthenticated.isPasswordResetEnabled()) {
        LoginUrlsWrapper.navigateToSignIn({});
        //this is just in case to make sure 
        return null;
    }
    if (showPasswordResetForm) {
        return <PasswordResetForm
        onSubmit={() => setShowPasswordResetForm(false)} />;
    }
    else {
        return (
            <div className='tb-login'>
                <span className='tb-login-form-container' >
                    <SignInLogo />
                    <div className='tb-password-reset-msg'>
                        <div className='tb-login-msg tb-password-reset-success'>
                            <div>{Messages.passwordResetSuccess()}</div>
                            <div className='tb-restart-password-reset'>
                                <span>{Messages.unreceivedPasswordResetEmail()}</span>
                                <ButtonWidget buttonType={ButtonType.Outline}
                                    testId='resendPasswordReset'
                                    onClick={() => setShowPasswordResetForm(true)}
                                    title={Messages.requestPasswordResetAgain()}
                                >
                                    {Messages.requestPasswordResetAgain()}
                                </ButtonWidget>
                            </div>
                        </div>
                    </div>
                </span>
            </div>
        );
    }
}